import { View, ViewEvent } from "../view/index";
import { BaseApp } from "../app";
import { Template, LazyTemplate } from "../template/index";

export default class ToastManager
{
    private containerElement: HTMLElement;
    private app: BaseApp;

    constructor(app: BaseApp)
    {
        this.app = app;
        this.containerElement = <HTMLElement>document.querySelector('[data-toast-container]');
    }

    /**
     * Displays a toast message. Returns a promise that resolves when the toast message is dismissed/removed.
     * @param message The message to display.
     * @param duration How long the message is displayed (ms).
     * @param iconClassNames Optional icon classes for the message icon.
     */
    public show(message: string, duration = undefined, iconClassNames: string = undefined, isSticky = false, encode = true): PromiseLike<void>
    {
        duration = duration !== undefined ? duration : this.app.settings.toasts.defaultDuration;

        return new Promise((resolve, reject) =>
        {
            let toast = new ToastMessage(message, iconClassNames, isSticky, encode);

            this.app.renderPartialView(toast).then(() =>
            {
                this.containerElement.appendChild(toast.element);
                
                toast.on(ViewEvent.UNLOAD, resolve);
                if (!isSticky)
                {
                    setTimeout(() => toast.close(), duration);
                }
            });
        });
    }
}

export class ToastMessage extends View
{
    public template: LazyTemplate = Template.inline(`
    <div class="item{{? it.isSticky }} sticky{{?}}">
        {{? it.iconClassNames}}
        <i class="icon {{=it.iconClassNames}}"></i>
        {{?}}
        <header>
        {{? it.encode}}
            {{=it.message}}
        {{??}}
            {{!it.message}}
        </header>
        {{?}}
    </div>
    `);

    public message: string;
    public duration: number;
    public iconClassNames: string;
    public isSticky: boolean;
    public encode: boolean;

    constructor(message: string, iconClassNames: string = undefined, isSticky = false, encode = true)
    {
        super();
        this.message = message;
        this.iconClassNames = iconClassNames;
        this.isSticky = isSticky;
        this.encode = encode;
    }

    private onTransitionEnd = (e: Event) =>
    {

    };

    public afterRender(): PromiseLike<void>
    {
        this.element.addEventListener('click', e => this.close());
        setTimeout(() => this.element.classList.add('visible'), 1);
        return super.afterRender();
    }

    public close(): PromiseLike<void>
    {
        return new Promise((resolve, reject) =>
        {
            this.element.addEventListener('transitionend', () =>
            {
                super.close().then(resolve);
            });
            this.element.classList.remove('visible');
        });
    }

    public unload(): PromiseLike<void>
    {
        this.element.parentElement.removeChild(this.element);
        return super.unload();
    }
}